import { Pencil, Trash2, Users, MapPin, Gem, Paperclip } from "lucide-react";

export const OPP_STATUS = { planned: "مخطط لها", open: "مفتوحة", done: "منفذة", cancelled: "ملغاة" };

const STATUS_CHIP = {
  open: "bg-white text-turq-900",
  planned: "bg-white/60 text-turq-900",
  cancelled: "bg-coral-900 text-white",
};
const statusChipCls = (status) => STATUS_CHIP[status] || "bg-white/25";

export function OppCard({ o, onParts, onAtts, onEdit, onDelete }) {
  const attachCount = Object.keys(o.attachments || {}).length;
  return (
    <div data-testid={`opportunity-card-${o.id.slice(0, 8)}`}
      className="bg-surface rounded-2xl overflow-hidden shadow-md border border-brd/50 hover:shadow-lg transition-shadow">
      <div className="h-20 px-4 flex items-start justify-between pt-3 text-white"
        style={{ background: "linear-gradient(120deg,#0F8896,#FF7A59)" }}>
        <span className="text-[11px] font-bold bg-white/20 rounded-full px-3 py-1">{o.category}</span>
        <span className={`text-[11px] font-bold rounded-full px-3 py-1 ${statusChipCls(o.status)}`}>
          {OPP_STATUS[o.status] || "منفذة"}
        </span>
      </div>
      <div className="p-4">
        <h4 className="font-head font-bold text-[15px] mb-2">{o.name}</h4>
        <div className="flex items-center gap-1.5 flex-wrap mb-2">
          <span data-testid={`opp-main-value-${o.id.slice(0, 8)}`}
            className="text-[10.5px] font-bold bg-coral-100 text-coral-900 dark:bg-surface2 dark:text-coral-300 rounded-full px-2.5 py-1 flex items-center gap-1">
            <Gem className="w-3 h-3" /> {o.main_value}
          </span>
          {(o.supporting_values || []).map((v) => (
            <span key={v} className="text-[10.5px] font-bold bg-turq-100 text-turq-900 dark:bg-surface2 dark:text-turq-300 rounded-full px-2.5 py-1">{v}</span>
          ))}
        </div>
        {o.expected_impact && <p className="text-[11px] text-mutext mb-2">الأثر المتوقع: {o.expected_impact}</p>}
        <div className="text-[11px] text-mutext space-y-1 mb-3">
          {o.location && <div className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {o.location}</div>}
          <div>{o.start_date} {o.end_date && o.end_date !== o.start_date ? `→ ${o.end_date}` : ""}</div>
        </div>
        <div className="flex items-center justify-between border-t border-brd/50 pt-3">
          <button data-testid={`opp-participants-${o.id.slice(0, 8)}`} onClick={() => onParts(o)}
            className="text-[11px] font-bold text-turq-600 hover:text-turq-900 flex items-center gap-1">
            <Users className="w-3.5 h-3.5" /> {o.participants} مشارك · {o.hours_total ?? o.hours} ساعة
          </button>
          <div className="flex gap-1.5">
            <button data-testid={`opp-attachments-${o.id.slice(0, 8)}`}
              onClick={() => onAtts(o)} title="مرفقات الفرصة"
              className="w-7 h-7 rounded-lg bg-turq-100 dark:bg-surface2 flex items-center justify-center relative">
              <Paperclip className="w-3 h-3 text-turq-900 dark:text-turq-300" />
              {attachCount > 0 && (
                <span data-testid={`opp-attach-count-${o.id.slice(0, 8)}`}
                  className="absolute -top-1.5 -left-1.5 min-w-[14px] h-3.5 px-0.5 rounded-full bg-coral-600 text-white text-[9px] font-bold flex items-center justify-center">
                  {attachCount}
                </span>
              )}
            </button>
            <button data-testid={`opp-edit-${o.id.slice(0, 8)}`} onClick={() => onEdit(o)}
              className="w-7 h-7 rounded-lg bg-beige-600 dark:bg-surface2 flex items-center justify-center">
              <Pencil className="w-3 h-3 text-turq-900 dark:text-turq-300" />
            </button>
            <button data-testid={`opp-delete-${o.id.slice(0, 8)}`} onClick={() => onDelete(o)}
              className="w-7 h-7 rounded-lg bg-coral-100 dark:bg-surface2 flex items-center justify-center">
              <Trash2 className="w-3 h-3 text-coral-900 dark:text-coral-300" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
